import "core-js/modules/es.function.name";
import { toDisplayString as _toDisplayString, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue";

var _hoisted_1 = /*#__PURE__*/_createVNode("hr", null, null, -1);

var _hoisted_2 = {
  class: "level"
};
var _hoisted_3 = {
  class: "level-item has-text-centered"
};
var _hoisted_4 = {
  class: "image is-64x64"
};
var _hoisted_5 = {
  class: "level-item has-text-centered"
};
var _hoisted_6 = {
  class: "heading"
};
var _hoisted_7 = {
  class: "title"
};
var _hoisted_8 = {
  class: "level-item has-text-centered"
};
var _hoisted_9 = {
  class: "heading"
};
var _hoisted_10 = {
  class: "title"
};
var _hoisted_11 = {
  class: "level-item has-text-centered"
};
var _hoisted_12 = {
  class: "heading"
};
var _hoisted_13 = {
  class: "title"
};
var _hoisted_14 = {
  class: "level-item has-text-centered"
};
var _hoisted_15 = {
  class: "heading"
};
var _hoisted_16 = {
  class: "title"
};

var _hoisted_17 = /*#__PURE__*/_createVNode("hr", null, null, -1);

var _hoisted_18 = {
  key: 0,
  class: "has-text-grey-light is-size-7",
  style: {
    "margin-bottom": "10px"
  }
};

var _hoisted_19 = /*#__PURE__*/_createVNode("span", {
  class: "icon is-small"
}, [/*#__PURE__*/_createVNode("i", {
  class: "fas fa-retweet"
})], -1);

var _hoisted_20 = {
  class: "media"
};
var _hoisted_21 = {
  class: "media-left"
};
var _hoisted_22 = {
  class: "image is-48x48"
};
var _hoisted_23 = {
  class: "media-content"
};
var _hoisted_24 = {
  class: "content"
};
var _hoisted_25 = {
  class: "has-text-grey-light"
};
var _hoisted_26 = {
  class: "level is-mobile"
};
var _hoisted_27 = {
  class: "level-left"
};

var _hoisted_28 = /*#__PURE__*/_createVNode("span", {
  class: "icon is-small"
}, [/*#__PURE__*/_createVNode("i", {
  class: "fas fa-retweet"
})], -1);

var _hoisted_29 = /*#__PURE__*/_createVNode("span", {
  class: "icon is-small"
}, [/*#__PURE__*/_createVNode("i", {
  class: "fas fa-heart"
})], -1);

export function render(_ctx, _cache) {
  return _openBlock(), _createBlock(_Fragment, null, [_createVNode("h3", {
    class: "subtitle is-4",
    alt: _ctx.locale
  }, _toDisplayString(_ctx.t("message.components.twitterTimeline.stats")), 9, ["alt"]), _hoisted_1, _createVNode("div", _hoisted_2, [_createVNode("div", _hoisted_3, [_createVNode("figure", _hoisted_4, [_createVNode("img", {
    class: "is-rounded",
    src: _ctx.user.profile_image_url_https,
    alt: _ctx.user.name + ' - ' + _ctx.user.location
  }, null, 8, ["src", "alt"])])]), _createVNode("div", _hoisted_5, [_createVNode("div", null, [_createVNode("p", _hoisted_6, _toDisplayString(_ctx.t("message.components.twitterTimeline.tweets")), 1), _createVNode("p", _hoisted_7, _toDisplayString(_ctx.user.statuses_count), 1)])]), _createVNode("div", _hoisted_8, [_createVNode("div", null, [_createVNode("p", _hoisted_9, _toDisplayString(_ctx.t("message.components.twitterTimeline.favourites")), 1), _createVNode("p", _hoisted_10, _toDisplayString(_ctx.user.favourites_count), 1)])]), _createVNode("div", _hoisted_11, [_createVNode("div", null, [_createVNode("p", _hoisted_12, _toDisplayString(_ctx.t("message.components.twitterTimeline.followers")), 1), _createVNode("p", _hoisted_13, _toDisplayString(_ctx.user.followers_count), 1)])]), _createVNode("div", _hoisted_14, [_createVNode("div", null, [_createVNode("p", _hoisted_15, _toDisplayString(_ctx.t("message.components.twitterTimeline.following")), 1), _createVNode("p", _hoisted_16, _toDisplayString(_ctx.user.friends_count), 1)])])]), (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.tweets, function (tweetData) {
    return _openBlock(), _createBlock("div", {
      key: tweetData.id_str
    }, [_hoisted_17, tweetData.rt ? (_openBlock(), _createBlock("p", _hoisted_18, [_hoisted_19, _createTextVNode(" " + _toDisplayString(tweetData.rt) + " Retweeted ", 1
    /* TEXT */
    )])) : _createCommentVNode("", true), _createVNode("article", _hoisted_20, [_createVNode("figure", _hoisted_21, [_createVNode("p", _hoisted_22, [_createVNode("img", {
      src: tweetData.user.profile_image_url_https,
      class: "is-rounded"
    }, null, 8, ["src"])])]), _createVNode("div", _hoisted_23, [_createVNode("div", _hoisted_24, [_createVNode("p", null, [_createVNode("strong", null, _toDisplayString(tweetData.user.name), 1), _createVNode("small", null, " @" + _toDisplayString(tweetData.user.screen_name), 1), _createVNode("small", _hoisted_25, " - " + _toDisplayString(_ctx.fromNow(tweetData.created_at)), 1)]), _createVNode("div", {
      class: "has-text-grey",
      innerHTML: tweetData.text
    }, null, 8, ["innerHTML"])]), (_openBlock(true), _createBlock(_Fragment, null, _renderList(tweetData.entities.media, function (media) {
      return _openBlock(), _createBlock("p", {
        class: "image",
        key: media.id_str
      }, [_createVNode("img", {
        src: media.media_url_https
      }, null, 8, ["src"])]);
    }), 128
    /* KEYED_FRAGMENT */
    )), _createVNode("nav", _hoisted_26, [_createVNode("div", _hoisted_27, [_createVNode("a", {
      class: "level-item has-text-grey-light",
      _target: "_blank",
      href: 'https://twitter.com/intent/retweet?tweet_id=' + tweetData.id_str
    }, [_hoisted_28, _createVNode("small", null, " " + _toDisplayString(tweetData.retweet_count), 1)], 8, ["href"]), _createVNode("a", {
      class: "level-item has-text-grey-light",
      _target: "_blank",
      href: 'https://twitter.com/intent/like?tweet_id=' + tweetData.id_str
    }, [_hoisted_29, _createVNode("small", null, " " + _toDisplayString(tweetData.favorite_count), 1)], 8, ["href"])])])])])]);
  }), 128
  /* KEYED_FRAGMENT */
  ))], 64
  /* STABLE_FRAGMENT */
  );
}